'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDomFactories = require('react-dom-factories');

var _reactDomFactories2 = _interopRequireDefault(_reactDomFactories);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _CwImage = require('./CwImage.scss');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwImage = function (_React$Component) {
  (0, _inherits3.default)(CwImage, _React$Component);

  function CwImage() {
    (0, _classCallCheck3.default)(this, CwImage);
    return (0, _possibleConstructorReturn3.default)(this, (CwImage.__proto__ || (0, _getPrototypeOf2.default)(CwImage)).apply(this, arguments));
  }

  (0, _createClass3.default)(CwImage, [{
    key: 'render',
    value: function render() {
      var imageClass = (0, _classnames2.default)(this.props.className, (0, _defineProperty3.default)({}, _CwImage2.default.cursor, this.props.onClick));

      if (this.props.isInlineSVG) {
        return _react2.default.createElement(
          'div',
          {
            'data-cwid': this.props.cwId,
            title: this.props.title,
            onClick: this.props.onClick,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur },
          _react2.default.createElement(_reactInlinesvg2.default, {
            className: imageClass,
            style: this.props.style,
            wrapper: _reactDomFactories2.default.div,
            key: this.props.src,
            src: this.props.src,
            cacheGetRequests: true
          })
        );
      }

      return _react2.default.createElement('img', {
        'data-cwid': this.props.cwId,
        title: this.props.title,
        className: imageClass,
        style: this.props.style,
        src: this.props.src,
        alt: this.props.alt,
        onClick: this.props.onClick,
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur
      });
    }
  }]);
  return CwImage;
}(_react2.default.Component);

CwImage.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Path to image
   */
  src: _propTypes2.default.string.isRequired,
  /**
   * Callback fired when image is clicked
   */
  onClick: _propTypes2.default.func,
  /**
   * Alt text used for screen readers
   */
  alt: _propTypes2.default.string,
  /**
   * Controls whether svg or img tag is rendered
   */
  isInlineSVG: _propTypes2.default.bool,
  /**
   * Used to add custom css
   */
  className: _propTypes2.default.string,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * Override the styles of the root element
   */
  style: _propTypes2.default.object,
  /**
   * HTML title attribute
   */
  title: _propTypes2.default.string
};

CwImage.defaultProps = {
  isInlineSVG: true
};

exports.default = CwImage;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwimage/CwImage.js
// module id = 22
// module chunks = 10